
<form id="journeyEsigningForm" name="journeyEsigningForm" #journeyEsigningForm="ngForm" (ngSubmit)="onSubmit()"
                dnErrorControl="errorControl" #errorControl="dnErrorControl" scrollToErrorForm>
    <dn-progress-spinner text="" *ngIf="showSpinner"></dn-progress-spinner>
    <div>
        <input-email  name="signerEmail" [autofocus]="true" 
                    [editable]="true" 
                    label="{{'esign.emailLabel' | translate}}">
        </input-email>
         <div class="mt-3 form-group">
            <label for="taxId" >{{'esign.taxIdLabel' | translate}}</label>
            <input type="text" class="form-control" id="taxId" name="taxId" 
              mask="0*" minlength="3" maxlength="20" placeholder="123456789" 
                    [(ngModel)]="taxId" required  dnDisplayErrors />
        </div>
    </div>
    
    <div class="mt-4 d-flex justify-content-center">
        <button type="submit" class="btn btn-primary"  #subButton
            [disabled]="!journeyEsigningForm.form.valid || submitted">Continue <i class="fa-solid fa-spinner" *ngIf="submitted"></i></button>
    </div>
</form>
